/* Width-guide suggestions: live Shopify candidates, matched to one available variant.
   Measurements and selected fit stay in this document. Candidate requests contain only
   collection, sales sort and page; ambiguous catalogue values never become a fit claim. */
(function () {
  'use strict';
  var states = new WeakMap();
  var MAX_PAGES = 3, MAX_PRODUCTS = 12, MAX_MATCHES = 3, TIMEOUT = 10000;
  var CODE = /^(?:\d{1,2}[AEW]|A{1,4}|E{1,4}|[BCDMNRSW]|SS|MW|X{1,2}W?)$/;

  function text(value) { return typeof value === 'string' ? value.trim() : ''; }
  function numericId(value) { return typeof value === 'string' && /^[1-9]\d*$/.test(value); }
  function size(value) {
    var raw = text(value).replace(/\s+/g, ' ');
    if (/^\d+(?:\.\d+)?$/.test(raw)) return String(Number(raw));
    return raw.toLowerCase();
  }
  function codes(value) {
    return text(value).toUpperCase().split(/[\s,;\/|&+]+/).filter(function (part) { return CODE.test(part); });
  }
  function widthCode(value) {
    var raw = text(value).toUpperCase(), brackets = raw.match(/\(([^()]*)\)/g);
    if (brackets && brackets.length !== 1) return '';
    var source = brackets ? brackets[0].slice(1, -1).trim() : raw;
    // A single literal code is intentional: no "Wide" inference, range or code equivalence.
    return CODE.test(source) ? source : '';
  }
  function audience(value) {
    var raw = text(value).toLowerCase();
    if (raw === 'women' || raw === 'female') return 'women';
    if (raw === 'men' || raw === 'male') return 'men';
    return '';
  }
  function sameOrigin(value, kind) {
    try {
      var url = new URL(value, window.location.href);
      if (url.origin !== window.location.origin || url.username || url.password) return null;
      var route = kind === 'product' ? 'products' : 'collections';
      if (!(new RegExp('^/(?:[a-z]{2}(?:-[a-z]{2})?/)?' + route + '/[a-z0-9][a-z0-9_-]*/?$', 'i')).test(url.pathname)) return null;
      url.search = ''; url.hash = '';
      return url;
    } catch (error) { return null; }
  }
  function imageURL(value) {
    if (!text(value)) return '';
    try {
      var url = new URL(value, window.location.href);
      if (url.username || url.password) return '';
      if (url.origin === window.location.origin && /^(https?:)$/.test(url.protocol)) return url.href;
      return url.protocol === 'https:' && url.hostname === 'cdn.shopify.com' && !url.port ? url.href : '';
    } catch (error) { return ''; }
  }
  function node(tag, className, content) {
    var result = document.createElement(tag);
    if (className) result.className = className;
    if (content) result.textContent = content;
    return result;
  }
  function mount(box) {
    var existing = box.querySelector('.hfs-wf-products');
    if (existing) return existing;
    var result = node('section', 'hfs-wf-products');
    result.hidden = true;
    result.setAttribute('data-clarity-mask', 'true');
    result.setAttribute('data-nosnippet', '');
    var answer = box.querySelector('#hfs-wf-result');
    if (answer) answer.insertAdjacentElement('afterend', result);
    else box.appendChild(result);
    return result;
  }
  function clear(box) {
    if (!box || !box.querySelector) return;
    var old = states.get(box);
    if (old) {
      old.cancelled = true;
      old.controller.abort();
      window.clearTimeout(old.timer);
      states.delete(box);
    }
    var area = box.querySelector('.hfs-wf-products');
    if (area) { area.hidden = true; area.replaceChildren(); }
  }
  function current(box, state) { return states.get(box) === state && !state.cancelled && box.isConnected; }
  function readPayload(html, page) {
    if (typeof html !== 'string' || html.length > 2000000) throw new Error('Candidate response unavailable');
    // Template contents stay inert: a fallback HTML response cannot load its images or frames.
    var template = document.createElement('template');
    template.innerHTML = html;
    var scripts = template.content.querySelectorAll('script[data-hfs-width-candidates]');
    if (scripts.length !== 1) throw new Error('Candidate response missing');
    var data = JSON.parse(scripts[0].textContent);
    if (!data || data.version !== 1 || data.sort !== 'best-selling' || data.page !== page ||
        !Array.isArray(data.products) || data.products.length > MAX_PRODUCTS ||
        !/^[A-Z]{3}$/.test(data.currency) ||
        !(data.nextPage === null || data.nextPage === page + 1)) throw new Error('Candidate response invalid');
    var currencies = typeof Intl.supportedValuesOf === 'function' ? Intl.supportedValuesOf('currency') : ['USD', 'CAD', 'GBP', 'EUR', 'AUD', 'NZD', 'JPY', 'CHF'];
    if (currencies.indexOf(data.currency) === -1) throw new Error('Candidate currency unavailable');
    new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: data.currency }).format(0);
    return data;
  }
  function match(product, selection, wantedCodes) {
    if (!product || !numericId(product.id) || product.hidden !== false || audience(product.gender) !== selection.audience ||
        !text(product.title) || product.title.length > 500 || !text(product.group) || !text(product.vendor) ||
        !Number.isInteger(product.variantCount) || product.variantCount < 1 || product.variantCount > 250 ||
        !Array.isArray(product.options) || !Array.isArray(product.variants) || product.variants.length > product.variantCount) return null;
    var url = sameOrigin(product.url, 'product');
    if (!url) return null;
    var names = product.options.map(function (option) { return text(option).toLowerCase().replace(/\s+/g, ' '); });
    if (!names.length || names.length > 3 || names.some(function (name) { return !name; }) || new Set(names).size !== names.length) return null;
    var sizes = [], widths = [];
    names.forEach(function (name, index) {
      if (name === 'size' || name === 'sizes' || name === 'shoe size') sizes.push(index);
      if (name === 'width' || name === 'widths') widths.push(index);
    });
    if (sizes.length !== 1 || widths.length !== 1) return null;
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      if (!variant || variant.available !== true || !numericId(variant.id) || !Array.isArray(variant.options) ||
          variant.options.length !== names.length || variant.options.some(function (value) { return !text(value); }) ||
          !Number.isSafeInteger(variant.price) || variant.price < 0) continue;
      var rawSize = variant.options[sizes[0]], rawWidth = variant.options[widths[0]];
      if (size(rawSize) !== size(selection.size) || wantedCodes.indexOf(widthCode(rawWidth)) === -1) continue;
      url.searchParams.set('variant', variant.id);
      return {
        key: text(product.vendor).toLowerCase() + '\u0000' + text(product.group).toLowerCase(),
        title: text(product.title), url: url.pathname + url.search, price: variant.price,
        image: imageURL(variant.image) || imageURL(product.image), size: rawSize, width: rawWidth
      };
    }
    return null;
  }
  function card(item, currency) {
    var li = node('li', 'hfs-wf-product'), link = node('a', 'hfs-wf-product-link');
    link.href = item.url;
    var fallback = function () { return node('span', 'hfs-wf-product-image hfs-wf-product-image--placeholder', 'View shoe'); };
    if (item.image) {
      var image = node('img', 'hfs-wf-product-image');
      image.width = 120; image.height = 120; image.alt = ''; image.loading = 'lazy'; image.decoding = 'async';
      image.referrerPolicy = 'no-referrer';
      image.addEventListener('error', function () { if (image.isConnected) image.replaceWith(fallback()); }, { once: true });
      image.src = item.image;
      link.appendChild(image);
    } else link.appendChild(fallback());
    var info = node('div', 'hfs-wf-product-info');
    info.appendChild(node('span', 'hfs-wf-product-title', item.title));
    info.appendChild(node('span', 'hfs-wf-product-price', new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency', currency: currency
    }).format(item.price / 100)));
    info.appendChild(node('span', 'hfs-wf-product-fit', 'Size ' + item.size + ' · ' + item.width));
    link.appendChild(info); li.appendChild(link);
    return li;
  }
  async function show(box, selection, browseUrl) {
    clear(box);
    if (!box || !box.isConnected || !selection || !['women', 'men'].includes(selection.audience) ||
        !text(selection.size) || text(selection.size).length > 40) return;
    var wantedCodes = codes(selection.widthCodes), base = sameOrigin(browseUrl, 'collection');
    if (!wantedCodes.length || !base || !window.fetch || !window.AbortController) return;
    // Copy fit intent before awaiting: a caller changing its object cannot change an in-flight result.
    selection = { audience: selection.audience, size: selection.size };
    var area = mount(box), status = node('p', 'hfs-wf-products-status', 'Finding shoe options…');
    status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); status.setAttribute('aria-atomic', 'true');
    area.appendChild(status); area.hidden = false;
    var state = { controller: new AbortController(), cancelled: false, timer: null };
    states.set(box, state);
    state.timer = window.setTimeout(function () {
      if (current(box, state)) {
        state.cancelled = true;
        status.textContent = 'Shoe suggestions could not load. You can still browse shoes by size above.';
        state.controller.abort();
      }
    }, TIMEOUT);
    var found = [], seen = new Set(), page = 1, currency = null;
    try {
      for (var run = 0; run < MAX_PAGES && page && found.length < MAX_MATCHES; run++) {
        var request = new URL(base.href);
        request.searchParams.set('sort_by', 'best-selling');
        request.searchParams.set('section_id', 'hfs-width-recommendations');
        request.searchParams.set('page', String(page));
        var response = await fetch(request.pathname + request.search, {
          credentials: 'same-origin', referrerPolicy: 'no-referrer', signal: state.controller.signal, cache: 'no-store'
        });
        if (!current(box, state)) return;
        if (!response.ok) throw new Error('Candidate request failed');
        var data = readPayload(await response.text(), page);
        if (!current(box, state)) return;
        if (currency && currency !== data.currency) throw new Error('Candidate currency changed');
        currency = data.currency;
        for (var i = 0; i < data.products.length && found.length < MAX_MATCHES; i++) {
          var item = match(data.products[i], selection, wantedCodes);
          if (item && !seen.has(item.key)) { seen.add(item.key); found.push(item); }
        }
        page = data.nextPage;
      }
      if (!current(box, state)) return;
      if (!found.length) {
        status.textContent = 'No matching suggestions found among the styles checked. You can still browse shoes by size above.';
        return;
      }
      var heading = node('h3', 'hfs-wf-products-title', 'Popular options in your size and width');
      var note = node('p', 'hfs-wf-products-note', 'Available to order. Check the brand’s fit guidance.');
      var list = node('ul', 'hfs-wf-product-list');
      list.setAttribute('role', 'list');
      found.forEach(function (item) { list.appendChild(card(item, currency)); });
      area.insertBefore(heading, status); area.insertBefore(note, status); area.appendChild(list);
      status.textContent = found.length + (found.length === 1 ? ' shoe option found.' : ' shoe options found.');
      status.classList.add('visually-hidden');
    } catch (error) {
      if (current(box, state)) status.textContent = 'Shoe suggestions could not load. You can still browse shoes by size above.';
    } finally { window.clearTimeout(state.timer); }
  }
  window.HFSWidthRecommendations = { show: show, clear: clear };
})();
